export const mailboxes = {
    germanMailbox: "de.vspost@bmw.de"
};
